const actionType = {

    PATIENT_REGISTER_SUCCESS : "PATIENT_REGISTER_SUCCESS",
    PATIENT_REGISTER_FAILURE : "PATIENT_REGISTER_FAILURE",
    NEW_FACILITY_REQUEST_SUCCESS : "NEW_FACILITY_REQUEST_SUCCESS",
    NEW_FACILITY_REQUEST_FAILURE : "NEW_FACILITY_REQUEST_FAILURE",
    
    PATIENT_REQUEST_INFO_SUCCESS: "PATIENT_REQUEST_INFO_SUCCESS",
    PATIENT_REQUEST_INFO_FAILURE: "PATIENT_REQUEST_INFO_FAILURE",
    
    GET_BY_PRACTICE_SUCCESS : "GET_BY_PRACTICE_SUCCESS",
    GET_BY_PRACTICE_FAILURE : "GET_BY_PRACTICE_FAILURE",

    GET_BY_DOCTOR_SUCCESS : "GET_BY_DOCTOR_SUCCESS",
    GET_BY_DOCTOR_FAILURE : "GET_BY_DOCTOR_FAILURE",

    GET_BY_LOCATION_SUCCESS : "GET_BY_LOCATION_SUCCESS",
    GET_BY_LOCATION_FAILURE : "GET_BY_LOCATION_FAILURE",

    SEARCH_BY_ALL_SUCCESS : "SEARCH_BY_ALL_SUCCESS",
    SEARCH_BY_ALL_FAILURE : "SEARCH_BY_ALL_FAILURE",

    FACILITY_LIST_SUCCESS : "FACILITY_LIST_SUCCESS",
    FACILITY_LIST_FAILURE : "FACILITY_LIST_FAILURE",

    GET_RECORDS_LIST_SUCCESS : "GET_RECORDS_LIST_SUCCESS",
    GET_RECORDS_LIST_FAILURE : "GET_RECORDS_LIST_FAILURE",

    GET_RESPONSE_TIME_LIST_SUCCESS : "GET_RESPONSE_TIME_LIST_SUCCESS",
    GET_RESPONSE_LIST_TIME_FAILURE : "GET_RESPONSE_LIST_TIME_FAILURE",

    GET_AUTH_EXP_LIST_SUCCESS : "GET_AUTH_EXP_LIST_SUCCESS",
    GET_AUTH_EXP_LIST_FAILURE : "GET_AUTH_EXP_LIST_FAILURE",

    GET_FACILITY_ADDRESS_SUCCESS : "GET_FACILITY_ADDRESS_SUCCESS",
    GET_FACILITY_ADDRESS_FAILURE : "GET_FACILITY_ADDRESS_FAILURE",

    GET_APP_COST_SUCCESS : "GET_APP_COST_SUCCESS",
    GET_APP_COST_FAILURE : "GET_APP_COST_FAILURE",

    ADD_PAYMENT_METHOD_SUCCESS :"ADD_PAYMENT_METHOD_SUCCESS",
    ADD_PAYMENT_METHOD_FAILURE : "ADD_PAYMENT_METHOD_FAILURE",
     
    GET_PAYMENT_METHODS_SUCCESS : "GET_PAYMENT_METHODS_SUCCESS",
    GET_PAYMENT_METHODS_FAILURE : "GET_PAYMENT_METHODS_FAILURE",

    DELETE_PAYMENT_METHOD_SUCCESS  :"DELETE_PAYMENT_METHOD_SUCCESS",
    DELETE_PAYMENT_METHOD_FAILURE : "DELETE_PAYMENT_METHOD_FAILURE",
     
    IS_DEFAULT_CARD_SUCCESS : "IS_DEFAULT_CARD_SUCCESS",
    IS_DEFAULT_CARD_FAILURE : "IS_DEFAULT_CARD_FAILURE",

    IS_AUTO_PAY_SUCCESS : "IS_AUTO_PAY_SUCCESS",
    IS_AUTO_PAY_FAILURE : "IS_AUTO_PAY_FAILURE",

    COST_AGREE_SUCCESS : "COST_AGREE_SUCCESS",
    COST_AGREE_FAILURE : "COST_AGREE_FAILURE",
    
    MAKE_NEW_FACILITY_REQUEST : "MAKE_NEW_FACILITY_REQUEST",
    MAKE_PATIENT_REGISTER_STATUS: "MAKE_PATIENT_REGISTER_STATUS",

    CHARGE_FINAL_COST_SUCCESS : "CHARGE_FINAL_COST_SUCCESS",
    CHARGE_FINAL_COST_FAILURE : "CHARGE_FINAL_COST_FAILURE",

    DOWNLOAD_RECORDS_SUCCESS: "DOWNLOAD_RECORDS_SUCCESS",
    DOWNLOAD_RECORDS_FAILURE : "DOWNLOAD_RECORDS_FAILURE",

    VALIDATE_FEDEX_AVAIL_SUCCESS:"VALIDATE_FEDEX_AVAIL_SUCCESS",
    VALIDATE_FEDEX_AVAIL_FAILURE:"VALIDATE_FEDEX_AVAIL_FAILURE",

    GET_OTHER_CLASSIFICATIONS_SUCCESS : "GET_OTHER_CLASSIFICATIONS_SUCCESS",
    GET_OTHER_CLASSIFICATIONS_FAILURE  : "GET_OTHER_CLASSIFICATIONS_FAILURE",
    
    DISABLE_ACCOUNT_SUCCESS :"DISABLE_ACCOUNT_SUCCESS",
    DISABLE_ACCOUNT_FAILURE : "DISABLE_ACCOUNT_FAILURE",

    ENABLE_ACCOUNT_SUCCESS : "ENABLE_ACCOUNT_SUCCESS",
    ENABLE_ACCOUNT_FAILURE : "ENABLE_ACCOUNT_FAILURE",

    VERIFY_OTP_ENABLE_ACCOUNT_SUCCESS : "VERIFY_OTP_ENABLE_ACCOUNT_SUCCESS",
    VERIFY_OTP_ENABLE_ACCOUNT_FAILURE : "VERIFY_OTP_ENABLE_ACCOUNT_FAILURE",
    
    INITIAL_STATUS_NULLIFY : "INITIAL_STATUS_NULLIFY",

    AGREEPAY_NULL : "AGREEPAY_NULL",
    PAYMENT_NOT_ADDED : "PAYMENT_NOT_ADDED",
    PAYMENT_ADD_NAV_NULL: "PAYMENT_ADD_NAV_NULL"

  };
  export default actionType;
   